import {
  GET_BOOKINGS,
  GET_BOOKINGS_SUCCESS,
  GET_BOOKING_DETAILS,
  GET_BOOKING_DETAILS_SUCCESS,
  API_ERROR,
} from "./actionTypes";


export const getBookings = (filters, options) => {
  const filtersJSON = JSON.stringify(filters)
  const optionsJSON = JSON.stringify(options)

  return {
    type: GET_BOOKINGS,
    filters: filtersJSON,
    options: optionsJSON,
  }
}

export const getBookingsSuccess = data => {
  return {
    type: GET_BOOKINGS_SUCCESS,
    payload: data,
  }
}

export const getBookingDetails = id => {
  return {
    type: GET_BOOKING_DETAILS,
    payload: { id },
  }
}

export const getBookingDetailsSuccess = data => {
  return {
    type: GET_BOOKING_DETAILS_SUCCESS,
    payload: data,
  }
}

export const apiError = error => {
  return {
    type: API_ERROR,
    payload: error,
  }
}
